import { IconDefinition } from "@fortawesome/fontawesome-common-types";
import toast from "react-hot-toast";
import { COLOURS } from "./colours";
import TailwindToast from "../components/TailwindToast";
import { faQuestion } from "@fortawesome/pro-solid-svg-icons";


export const myToast = ({ title, message, icon, colour, timing }: { title: string, message?: string, icon?: IconDefinition, colour?: COLOURS, timing?: number }) => {
  return toast.custom(t => <TailwindToast t={t} title={title} description={message} icon={icon || faQuestion} bg={colour} timing={timing} />)
}

export const _isTouchScreen = () => 'ontouchstart' in window || window.matchMedia('(any-pointer: coarse)').matches;